import type { Project } from "@beacon/core/projects"
import { pinnedFirst } from "@/design-system/data-table.ts"

/*
 * The order a short list of the Member's Projects takes wherever the web app shows only the first
 * few, as the sidebar and Home do: their Personal Project first, which the sidebar lists as My
 * Project instead, then by name, which is what the Member reads, so which ones make the cut is
 * never decided by something they can't see.
 */

/** A Project that may be the Member's Personal Project. */
type MaybePersonal = Partial<Pick<Project, "personal">>

/** `projects` with the Member's Personal Project first, the rest in the order they came. */
export function personalFirst<P extends MaybePersonal>(projects: readonly P[]) {
  return pinnedFirst(projects, (project) => project.personal === true)
}

/**
 * `projects` by name, in the Member's locale's order, after their Personal Project; the list passed
 * in is left as it was.
 */
export function projectsByName<P extends Pick<Project, "name"> & MaybePersonal>(
  projects: readonly P[],
) {
  return personalFirst(projects.toSorted((a, b) => a.name.localeCompare(b.name)))
}
